import { inject, injectable } from 'inversify';
import {
  ProfileServiceInterface,
  UpdateProfileRequestParams,
  UpdateProfileResponse,
} from './ProfileService.types';
import HttpClient from '../../../http';
import { backendUrl } from 'src/config';

@injectable()
class ProfileService implements ProfileServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public async updateProfile({
    userId,
    accessToken,
    data,
  }: UpdateProfileRequestParams) {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => !!value)
    );

    const response = await this.client
      .getClient()
      .patch<UpdateProfileResponse>(`/users/${userId}/`, filteredData, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });

    return response;
  }
}

export default ProfileService;
